import { ContractPriceStripTimeModel } from './contract-price-strip-time-model';

/**
 * AKA Time frame code, AKA profile
 */
export enum ContractFormulaType {
  'anytime' = 'anytime',
  'peak' = 'peak',
  'off_peak' = 'off_peak',
}

export const getTimeModelFromTimeFrameCode = (timeFrameCode: ContractFormulaType): ContractPriceStripTimeModel => {
  switch (timeFrameCode) {
    case ContractFormulaType.anytime:
      return ContractPriceStripTimeModel.anytime;
    case ContractFormulaType.peak:
    case ContractFormulaType.off_peak:
      return ContractPriceStripTimeModel.peak_off_peak;
    default:
      return undefined;
  }
};
